import { render, staticRenderFns } from "./classical-admin-evaluation-show.vue?vue&type=template&id=ceb80e56&scoped=true"
import script from "./classical-admin-evaluation-show.vue?vue&type=script&lang=js"
export * from "./classical-admin-evaluation-show.vue?vue&type=script&lang=js"
import style0 from "./classical-admin-evaluation-show.vue?vue&type=style&index=0&id=ceb80e56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb80e56",
  null
  
)

export default component.exports